module.exports = __webpack_public_path__ + "img/03.82ef591d.png";